import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "@/app/store";
import { RootState } from "@/app/rootReducer";
import {
  createDraftInvoiceAction,
  clearDraftInvoice,
} from "../slices/draftInvoiceSlice";
import { CreateDraftInvoiceRequest } from "@/api/createDraftInvoice/types";

export const useDraftInvoice = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { invoice, loading, error } = useSelector(
    (state: RootState) => state.draftInvoice,
  );

  const createDraft = (requestData: CreateDraftInvoiceRequest) => {
    dispatch(createDraftInvoiceAction(requestData));
  };

  const clearInvoice = () => {
    dispatch(clearDraftInvoice());
  };

  return {
    invoice,
    loading,
    error,
    createDraft,
    clearInvoice,
  };
};
